import React from 'react';
import Chart from 'react-apexcharts';
import { FormControl, InputLabel, Select as MuiSelect, MenuItem } from "@mui/material";

const FiveConsultantChart = ({ data = {}, topN = 5, onTopNChange }) => {
  console.log(data,"FiveConsultantChart");
  
  const consultantData = (data.consultantData && Array.isArray(data.consultantData) && data.consultantData.length > 0) 
    ? data.consultantData 
    : [
        { name: 'Dr. Rajesh Kumar', value: 45, sessions: 120, totalCompleted: 120, attempt: 150, missedAndCancelled: 20, percentage: 25.5, paidSessions: 80, freeSessions: 40 },
        { name: 'Dr. Priya Sharma', value: 35, sessions: 95, totalCompleted: 95, attempt: 120, missedAndCancelled: 15, percentage: 20.2, paidSessions: 65, freeSessions: 30 },
        { name: 'Dr. Amit Patel', value: 25, sessions: 78, totalCompleted: 78, attempt: 100, missedAndCancelled: 12, percentage: 16.6, paidSessions: 50, freeSessions: 28 },
        { name: 'Dr. Sunita Singh', value: 20, sessions: 65, totalCompleted: 65, attempt: 85, missedAndCancelled: 10, percentage: 13.8, paidSessions: 45, freeSessions: 20 },
        { name: 'Dr. Vikram Mehta', value: 15, sessions: 52, totalCompleted: 52, attempt: 70, missedAndCancelled: 8, percentage: 11.1, paidSessions: 35, freeSessions: 17 }
      ];
  
  console.log('FiveConsultantChart - consultantData:', consultantData);
  
  // Fixed height for scrollable chart (400px max, scrollable if more consultants)
  const chartHeight = 400;

  // Sort by totalCompleted (descending) for ranking
  const sortedData = [...consultantData].sort((a, b) => {
    const aCompleted = a.totalCompleted || a.sessions || 0;
    const bCompleted = b.totalCompleted || b.sessions || 0;
    return bCompleted - aCompleted;
  });

  // Prepare data for stacked bar chart
  // Total Attempt = Total Completed + Total Missed + Total Cancelled
  // Chart will show: Total Completed + Missed+Cancelled = Total Attempt (full bar length)
  const chartSeries = sortedData.map((consultant, index) => {
    const completed = Number(consultant.totalCompleted) || Number(consultant.sessions) || 0; // Completed consultations
    const missedCancelled = Number(consultant.missedAndCancelled) || 0; // Missed + Cancelled consultations
    const attempt = Number(consultant.attempt) || (completed + missedCancelled); // Total Attempt = Completed + Missed + Cancelled
    
    console.log(`Consultant ${index + 1} (${consultant.name || 'Unknown'}):`, {
      rawData: consultant,
      totalAttempt: attempt, // Total Attempt = Completed + Missed + Cancelled
      completed: completed,
      missedCancelled: missedCancelled,
      verification: `Total Attempt (${attempt}) = Completed (${completed}) + Missed+Cancelled (${missedCancelled})`
    });
    
    return {
      completed: completed,
      missedCancelled: missedCancelled,
      totalAttempt: attempt
    };
  });
  
  console.log('FiveConsultantChart - chartSeries:', chartSeries);
  console.log('FiveConsultantChart - Series Data:', {
    totalCompleted: chartSeries.map(item => item.completed),
    missedCancelled: chartSeries.map(item => item.missedCancelled),
    totalAttempt: chartSeries.map(item => item.totalAttempt)
  });

  const chartData = {
    series: [
      {
        name: 'Total Attempt',
        data: chartSeries.map(item => Number(item.totalAttempt) || 0)
      },
      {
        name: 'Total Completed',
        data: chartSeries.map(item => Number(item.completed) || 0)
      },
      {
        name: 'Missed + Cancelled',
        data: chartSeries.map(item => Number(item.missedCancelled) || 0)
      }
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            total: {
              enabled: false
            }
          }
        }
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          // Show labels for all segments
          return val > 0 ? val.toString() : '';
        },
        offsetX: 0,
        style: {
          fontSize: '12px',
          colors: ['#fff'],
          fontWeight: 'bold'
        }
      },
      colors: ['#10b981', '#3b82f6', '#ef4444'], // Green: Total Attempt, Blue: Total Completed, Red: Missed+Cancelled
      xaxis: {
        categories: sortedData.map((consultant, index) => {
          const completed = Number(consultant.totalCompleted) || Number(consultant.sessions) || 0;
          const attempt = Number(consultant.attempt) || 0;
          const conversionPercentage = attempt > 0 ? ((completed / attempt) * 100).toFixed(2) : '0.00';
          const name = consultant.name || 'Unknown';
          return `${name} - ${conversionPercentage}%`;
        }),
        labels: {
          formatter: function (val) {
            return val 
          }
        }
      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      grid: {
        borderColor: '#f1f1f1',
        strokeDashArray: 2,
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val 
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: {
              height: 300
            },
            dataLabels: {
              style: {
                fontSize: '10px'
              }
            }
          }
        }
      ]
    }
  };

  return (
    <div className="chart-container">
      <div className="chart-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h4>Top {topN} Consultants Performance</h4>
          <p>Ranked by total completed consultations</p>
        </div>
        <div style={{ minWidth: '180px' }}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Filter</InputLabel>
            <MuiSelect
              value={topN || 5}
              onChange={(e) => onTopNChange && onTopNChange(e.target.value)}
              label="Filter"
              sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3b82f6',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#3b82f6',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#3b82f6',
                },
              }}
            >
              <MenuItem value={5}>Top 5</MenuItem>
              <MenuItem value={10}>Top 10</MenuItem>
              <MenuItem value={15}>Top 15</MenuItem>
              <MenuItem value={20}>Top 20</MenuItem>
              <MenuItem value={30}>Top 30</MenuItem>
            </MuiSelect>
          </FormControl>
        </div>
      </div>
      <div style={{ 
        maxHeight: `${chartHeight}px`, 
        overflowY: 'auto', 
        overflowX: 'hidden',
        scrollbarWidth: 'thin',
        scrollbarColor: '#cbd5e1 #f1f5f9'
      }}>
        <style>{`
          div::-webkit-scrollbar {
            width: 8px;
          }
          div::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 10px;
          }
          div::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 10px;
          }
          div::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        `}</style>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={Math.max(chartHeight, sortedData.length * 40)}
        />
      </div>
    </div>
  );
};

export default FiveConsultantChart;
